module.exports = __webpack_public_path__ + "img/ZTOBUHaveOrder_04.d0b60a63.jpg";